module.exports = __webpack_public_path__ + "static/img/education1.45f98a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/education1.png
// module id = 8aVh
// module chunks = 1